export const iconFontAwesomeEducationShapes = (
	<i className="fa-solid fa-shapes"></i>
);
